import { renderType as datasourceRenderType } from '@atlaskit/link-datasource/elements';
import { Flex } from '@atlaskit/primitives';
import { FieldValueTypes } from '@databases/redux/connections/slice';
import React from 'react';

import PageStatus from './pageStatus/PageStatus';
import Tag from './tag/Tag';

type FieldType = FieldValueTypes['type'];
export type FieldTypeWithOnlyValues = {
  [K in FieldType]: {
    type: K;
    values: Extract<FieldValueTypes, { type: K }>['value'][];
    text: string | undefined;
  };
}[FieldType];

export type PropsRenderComponentType = (item: FieldTypeWithOnlyValues) => React.ReactNode;

const renderComponent: PropsRenderComponentType = (item) => {
  switch (item.type) {
    case 'boolean':
    case 'date':
    case 'datetime':
    case 'icon':
    case 'link':
    case 'number':
    case 'user':
    case 'status':
    case 'string':
    case 'time':
    case 'richtext':
      return datasourceRenderType(item);
    case 'tag':
      return (
        <Flex gap="space.050" wrap="wrap">
          {item.values.map((tag, key) => (
            <Tag key={key} text={tag.text} />
          ))}
        </Flex>
      );
    case 'html':
      return (
        <span dangerouslySetInnerHTML={{ __html: item.values.join('\n') || '' }}></span>
      );
    case 'pageStatus':
      return item.values.map((status) => (
        <PageStatus key={status.text} status={status} />
      ));
    default:
      // @ts-ignore
      return renderType({ type: 'string', values: [item.text] });
  }
};

export default renderComponent;
